import { Col, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Objective.css";

function Objective({
  id,
  description,
  dueDate,
  startDate,
  weight,
  status,
  lastCheckInProgress,
  lastCheckInStatus,
  lastCheckInDate,
  language,
}) {
  const { t } = useTranslation();

  const dayjs = require("dayjs");

  const navigate = useNavigate();

  const selectObjetiveStatusClass = (checkInStatus) => {
    switch (checkInStatus) {
      case "on-track":
        return "objective-card-onTrack";
      case "cautious":
        return "objective-card-cautious";
      case "at-risk":
        return "objective-card-atRisk";
      default:
        return "objective-card-onTrack";
    }
  };

  const selectObjetiveStatusBadge = (status) => {
    switch (status) {
      case "pending":
        return "objective-pending";
      case "approved":
        return "";
      case "rejected":
        return "objective-rejected";
      case "weight_request":
        return "objective-weight_request";
      case "closed":
        return "objective-closed";
      case "validated":
        return "objective-validated";
      default:
        return "objective-pending";
    }
  };

  const selectObjetiveStatusText = (status, language) => {
    let text = "";
    switch (status) {
      case "pending":
        if (language === "en") {
          text = "waiting for approval";
        } else if (language === "es") {
          text = "esperando aprobación";
        }
        return text;
      case "approved":
        return "";
      case "rejected":
        if (language === "en") {
          text = "rejected";
        } else if (language === "es") {
          text = "rechazado";
        }
        return text;
      case "weight_request":
        if (language === "en") {
          text = "change weight";
        } else if (language === "es") {
          text = "cambio peso";
        }
        return text;
      case "closed":
        if (language === "en") {
          text = "closed";
        } else if (language === "es") {
          text = "cerrado";
        }
        return text;
      case "validated":
        if (language === "en") {
          text = "validated";
        } else if (language === "es") {
          text = "validado";
        }
        return text;
      default:
        if (language === "en") {
          text = "waiting for approval";
        } else if (language === "es") {
          text = "esperando aprobación";
        }
        return text;
    }
  };

  const selectProgressBarClass = (lastCheckInStatus) => {
    switch (lastCheckInStatus) {
      case "on-track":
        return "progress-bar-onTrack";
      case "cautious":
        return "progress-bar-cautious";
      case "at-risk":
        return "progress-bar-atRisk";
      default:
        return "progress-bar-onTrack";
    }
  };

  return (
    <Col key={id} lg={4}>
      <Col
        className={selectObjetiveStatusClass(lastCheckInStatus)}
        onClick={() => navigate(`/objectives/details/${id}`)}
      >
        <Row className="align-items-center mb-2">
          <Col>
            <span className="weight">{weight}</span>
          </Col>
          <Col className="right">
            <span className={selectObjetiveStatusBadge(status)}>
              {selectObjetiveStatusText(status, language)}
            </span>
          </Col>
        </Row>

        <Col className="center">
          <p className="lastCheckIn">
            {lastCheckInDate ? dayjs(lastCheckInDate).format("D-MMM-YYYY") : ""}
          </p>
        </Col>

        <Col>
          <p className="description">{description}</p>
        </Col>
        <Row className="align-items-center">
          <Col>
            <Col className="date-container">
              <p className="dueDate">{dayjs(startDate).format("D-MMM-YYYY")}</p>
              <h6 className="dateLabel">{t("Objetivos.Detalles.Inicio")}</h6>
            </Col>
          </Col>
          <Col className="right">
            <Col className="date-container">
              <p className="dueDate">{dayjs(dueDate).format("D-MMM-YYYY")}</p>
              <h6 className="dateLabel">{t("Objetivos.Detalles.Termino")}</h6>
            </Col>
          </Col>
        </Row>

        <Col>
          <ProgressBar
            className={selectProgressBarClass(lastCheckInStatus)}
            now={lastCheckInProgress}
            label={`${lastCheckInProgress}%`}
          />
        </Col>
      </Col>
    </Col>
  );
}

export default Objective;
